import { CategoryType } from './types';

export const isInProgress = (category: CategoryType) =>
  category.is_incented ||
  ![0, 100].includes(category.current_progress) ||
  (category.current_progress === 0 && category.last_completed);
